import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Table, Data } from 'components/layout/Table'
import { assessors as assessorsLayout } from 'constants/layout'
import { get } from 'lodash'
import AssessorResendConfirmationModal from '../../../modals/assessors/AssessorResendConfirmationModal'
import MODALS from '../../../../constants/modals'
import moment from 'moment'
import { Link } from 'react-router-dom'
import config from '../../../../config'
import { FormattedDate } from '../../../intl'
import { Button } from '../../../misc'

export default class AssessorsRegistrationTable extends Component {
  static propTypes = {
    assessors: PropTypes.object.isRequired,
    activeOrganization: PropTypes.object.isRequired,
    permissions: PropTypes.object.isRequired,
    organizationHierarchyId: PropTypes.number,
    setAssessorsParams: PropTypes.func,
    setAssessorsRegistrationParams: PropTypes.func,
    isAccountRegistration: PropTypes.bool,
    onResendAssessorRegistration: PropTypes.func,
    onResendActivityCategoryRegistration: PropTypes.func,
    modal: PropTypes.func.isRequired
  }

  static defaultProps = {
    permissions: {},
    params: {},
    activeOrganization: {}
  }

  state = {
    id: null
  }

  handleOpenModal = id => {
    this.setState({ id })

    this.props.modal(MODALS.ASSESSOR_RESEND_CONFIRMATION_MODAL)
  }

  getInvitedBy = invitedBy => {

    if(!invitedBy){
      return '---'
    }

    if(get(invitedBy, 'participantDetail')){
      return (<Link
        to={{ pathname: `${config.publicPath}/participants/${get(invitedBy, 'id')}/detail` }}
      >
        {get(invitedBy, 'name')}
      </Link>)
    } else {
      return get(invitedBy, 'name')
    }

  }

  render() {
    const {
      setAssessorsParams,
      setAssessorsRegistrationParams,
      permissions,
      params,
      activeOrganization,
      isAccountRegistration,
      onResendAssessorRegistration,
      onResendActivityCategoryRegistration,
      modal
    } = this.props

    const loading = isAccountRegistration ? get(this.props.assessors, 'loading') : get(this.props.assessors, 'registrations.loading')

    const list = isAccountRegistration ? get(this.props.assessors, 'list') : get(this.props.assessors, 'registrations.list')

    const offset = isAccountRegistration ? get(this.props.assessors, 'offset') : get(this.props.assessors, 'registrations.offset')

    const limit = isAccountRegistration ? get(this.props.assessors, 'limit') : get(this.props.assessors, 'registrations.limit')

    const pages = isAccountRegistration ? get(this.props.assessors, 'pages') : get(this.props.assessors, 'registrations.pages')

    const sort = isAccountRegistration ? get(this.props.assessors, 'sort') : get(this.props.assessors, 'registrations.sort')

    return (
      <div>
        <Table
          loading={loading}
          length={list.length}
          offset={offset}
          limit={limit}
          pages={pages}
          sort={sort}
          ths={isAccountRegistration ? assessorsLayout.tableHeadersAccount() : assessorsLayout.tableRegistrationHeaders(true)}
          setParams={isAccountRegistration ?setAssessorsParams : setAssessorsRegistrationParams}
          permissions={permissions}
        >
          <Data>

            {list.map(item => {
              const invitationDate = isAccountRegistration ? get(item, 'invitationDate') : get(item, 'invitationDate')

              if(isAccountRegistration && !invitationDate){
                return
              }

              const organizationId = params.id || params.organizationId || activeOrganization.id

              const id = get(item, 'id')

              const assessorPersonId = isAccountRegistration ? null : get(item, 'assessor.person.id')

              const firstName = isAccountRegistration ? get(item, 'firstName') : get(item, 'assessor.person.firstName')

              const lastName = isAccountRegistration ? get(item, 'lastName') : get(item, 'assessor.person.lastName')

              const email = isAccountRegistration ? get(item, 'email') : get(item, 'assessor.person.email')

              const phoneNumber =  get(item, 'phoneNumber')

              const sectionName = get(item, 'activityCategory.activitySection.translationText')

              const categoryName = get(item, 'activityCategory.parent.translatedName')

              const name = get(item, 'activityCategory.translatedName')

              const dateMoment = moment(invitationDate)

              const dateField = dateMoment.isValid() ? dateMoment.fromNow() : invitationDate

              const pid = get(item, 'activity.award.participant.id')

              const participantName = get(item, 'activity.award.participant.name')

              const translatedType = get(item, 'activityCategory.parent.activitySection.translationText')

              return (<tr key={id}>
              {!isAccountRegistration && <td>
                <Link
                    to={{
                      pathname: `${config.publicPath}/organizations/${organizationId}/assessors/${assessorPersonId}/detail`
                    }}
                >
                  {get(item, 'assessor.person.globalId') || assessorPersonId}
                </Link>
                </td>}
                <td>{isAccountRegistration ? get(item, 'name') : firstName}</td>
                {!isAccountRegistration &&<td>{lastName}</td>}
                <td>{email}</td>
                <td>{phoneNumber}</td>
                {!isAccountRegistration && <td>{pid && <Link
                    to={{ pathname: `${config.publicPath}/participants/${pid}/detail` }}
                >
                  {participantName}
                </Link>}</td>}
                {!isAccountRegistration && <td>
                  {translatedType}
                </td>}
                {!isAccountRegistration && <td>
                  {sectionName} - {categoryName} - {name}
                </td>}

                <td>
                  {this.getInvitedBy(get(item, 'invitedBy'))}
                </td>
                <td>
                  {<p>{invitationDate &&
                  <FormattedDate value={invitationDate} />} {invitationDate ? '(' + dateField + ')' : '---'}</p>}
                </td>
                <td>
                  <Button
                  type="button"
                  primary
                  onClick={() => this.handleOpenModal(id)}
                  intlKey="button.resend"
                  >
                  Resend
                  </Button>
                </td>
              </tr>)
            })}
          </Data>
        </Table>
        <AssessorResendConfirmationModal
            modalId={MODALS.ASSESSOR_RESEND_CONFIRMATION_MODAL}
            submitAction={isAccountRegistration ? onResendAssessorRegistration : onResendActivityCategoryRegistration}
            id={this.state.id}
            modal={modal}
        />
      </div>
    )
  }
}
